import { Link, NavLink } from "react-router-dom";
import { PawPrint, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Enroll" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-primary text-primary-foreground">
            <PawPrint className="h-5 w-5" />
          </span>
          <span className="font-display text-2xl uppercase tracking-wider text-white">
            Clawius
          </span>
        </Link>

        <nav className="hidden items-center gap-2 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `rounded-sm px-3 py-2 font-heading text-sm font-medium uppercase tracking-widest transition-colors ${
                  isActive ? "text-primary" : "text-zinc-300 hover:text-primary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/login" data-testid="nav-owner-login" className="ml-2">
            <Button variant="outline" size="sm" className="rounded-sm border-border bg-transparent font-heading uppercase tracking-wider text-white hover:border-primary hover:bg-secondary">
              Owner Login
            </Button>
          </Link>
        </nav>

        <button
          className="text-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-background px-6 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className="rounded-sm px-3 py-2 font-heading text-sm font-medium uppercase tracking-widest text-zinc-300 hover:bg-secondary"
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/login"
              onClick={() => setOpen(false)}
              className="rounded-sm px-3 py-2 font-heading text-sm font-semibold uppercase tracking-widest text-primary"
            >
              Owner Login
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
